// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","person-obituary":"person-obituary","person-content":"person-content","person-content__header":"person-content__header","person-content__picture":"person-content__picture","person-content__name-lifespan":"person-content__name-lifespan","description":"description","publisher":"publisher","person-obituary__read-more":"person-obituary__read-more"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/Obituaries/css/PersonObituary.styl
// module id = 1491
// module chunks = 0